<template>
  <div style="position: absolute; width: 100% !important;">
    <!-- Header -->
    <header class="site-header header-s1 is-sticky">
      <!-- Navbar -->
      <Menu />
      <!-- #end Navbar -->
    </header>
    <!-- End Header -->
    <div class="section">
      <div class="container" style="margin-top: 150px;">
        <h2 style="color: #161616;">Thanks for applying to Sundry Markets.</h2>
        <p>Your application has been submitted successfully. We will contact you soon.</p>
        <p><a href="/">Back to home</a></p>
      </div>
    </div>
  </div>

</template>

<script>
  import Menu from '../components/Menu'
  import Footer from '../components/Footer'
  export default {
    name: 'Feedback',
    components: {
      Menu,
      Footer
    }
  }
</script>